import * as Common from '@/agiles/common';
import { GroupMember } from './groupMember';

export class Group extends Common.User{
    constructor(){
        super();
        this.binders.users = new Common.ModelBinder(Common.GroupMember);
    }    
        // public id: string;
        // public name: string;
        public isGroup: boolean = true;
        public users: Common.GroupMember[] = new Array();
}

export class GroupQuery extends Common.LoadQuery {
  constructor() {
    super('GroupQuery', Group);
    this.sort = 'id';
  }
  public id :string ='';
  public name: string ='';
}

export class UserGroupQuery extends Common.Query {
  constructor() {
    super('UserGroupQuery', new Common.ModelBinder(GroupMember,true));
  }
}